"use client";

import getGameContainer from "@casino/ui/Games/getGameContainer";
import { useGamePageData } from "@casino/ui/Games/hooks";
import { GameControlsFairness } from "@workspace/frontend-ui";
import type { FC } from "react";

const FairnessButton: FC = () => {
  const { t } = useGamePageData();

  const handleShowFairness = () => getGameContainer()?.showProvablyFair();

  return (
    <GameControlsFairness
      data-testid="fairness-button"
      label={t("game.controls.fairness.label", "Fairness")}
      onClick={handleShowFairness}
    />
  );
};

export default FairnessButton;
